

const showDialog = () => {
  	  document.getElementById("dialog_men").classList.remove("show");
document.getElementById("BG").classList.remove("show2");
  document.getElementById("dialog_men").classList.remove("hide");
document.getElementById("BG").classList.remove("hide2");
  document.getElementById("dialog_men").classList.add("show");
document.getElementById("BG").classList.add("show2");
  const body = document.body;
  body.style.width = '100%';
};
  const closeDialog = () => {
  const body = document.body;
  document.getElementById("dialog_men").classList.add("hide");
document.getElementById("BG").classList.add("hide2");
}


  const showDialog2 = () => {
  	  document.getElementById("dialog_cart").classList.remove("show3");
document.getElementById("BG2").classList.remove("show2");
  document.getElementById("dialog_cart").classList.remove("hide3");
document.getElementById("BG2").classList.remove("hide2");
  document.getElementById("dialog_cart").classList.add("show3");
document.getElementById("BG2").classList.add("show2");
  const body = document.body;
  body.style.width = '100%';
};
  const closeDialog2 = () => {
  const body = document.body;
  document.getElementById("dialog_cart").classList.add("hide3");
document.getElementById("BG2").classList.add("hide2");
}